import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseTimeZone } from '../../common/hooks/useTimeZone'
import { Element } from '../../common/html/element'
import { FORMAT, formatDateTime } from '../../helpers/datetime'
import classes from './index.module.scss'

export const TriggerDate = ({ date }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()

  return (
    <Element className={classes.triggerDate}>
      <Translate value="alertDetail.TRIGGER_DATE" />
      :&nbsp;
      <span>{formatDateTime(date, FORMAT.DATE, locale, timezone)}</span>
    </Element>
  )
}
